module.exports = __webpack_public_path__ + "static/media/landing_sightseeing.ad3cf575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/landing_sightseeing.svg
// module id = 237
// module chunks = 27